import { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles/LeafletMap.module.scss';

export default class LeafletMap extends Component {
    static propTypes = {
        locations: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        center: PropTypes.array,
        address: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        zoom: PropTypes.number,
        handleMarkerClick: PropTypes.func,
    };

    static defaultProps = {
        center: [39.400641, -107.211390],
        zoom: 15,
        address: '',
        // draggable: false,
        handleMarkerClick: () => {
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            displayInsert: true,
            draggable: false,
            components: undefined
        };

        this.mapRef = createRef();
    }

    componentDidMount() {
        // const leaflet = require('leaflet');
        // leaflet.Map.prototype.getCon
        let {
            Map,
            Marker,
            Popup,
            TileLayer,
            ZoomControl,
        } = require('react-leaflet');
        const {icon, divIcon, point} = require('leaflet');
        const MarkerClusterGroup = require('react-leaflet-markercluster').default;
        this.setState({
            components: {
                icon,
                divIcon,
                point,
                Map,
                Marker,
                Popup,
                TileLayer,
                MarkerClusterGroup,
                ZoomControl,
            }
        });
    }

    handleClick = () => {
        if (!this.state.draggable) {
            this.setState({
                draggable: true,
            });
        }
    };

    getMapRef = () => {
        return this.mapRef.current;
    };

    render() {
        const {locations, zoom} = this.props;

        if (!this.state.components) {
            return <div/>;
        }

        let coordArray = [];
        if (typeof locations[0] === 'object' && typeof locations[0] !== null && !(locations[0] instanceof Array)) {
            coordArray = locations.map(item => {
                let address = null;
                if (item.address &&
                    item.city &&
                    item.state &&
                    item.zip) {
                    address =
                        <address className={"notranslate"}>
                            <div>{item.address}</div>
                            <div>{item.city}, {item.state} {item.zip}</div>
                        </address>
                }

                return {
                    ...item,
                    lat: item.coordinates ? item.coordinates.lat : '',
                    lng: item.coordinates ? item.coordinates.lng : '',
                    address: address,
                    popup: item.popup || null,
                    icon: item.icon,
                }
            })
        } else if (typeof locations[0] === 'object' && typeof locations[0] !== null && locations[0] instanceof Array) { // accepts array of coordinate arrays
            coordArray = locations.map(item => {
                return {
                    ...item,
                    lat: item[0],
                    lng: item[1],
                }
            });
        } else if (locations.coordinates) { // also accepts object with a coordinates key which is an object of { lat, lng }
            if (locations.title) {
                coordArray.push({
                    ...item,
                    lat: locations.coordinates.lat,
                    lng: locations.coordinates.lng,
                })
            } else {
                coordArray.push(locations.coordinates);
            }
        } else if (locations[0]) { // otherwise assumes location is single array of [ lat, lng ]
            coordArray.push({...item, lat: locations[0], lng: locations[1]})
        }

        const leafletMapContainerClassName = classNames({
            [styles.leafletMapContainer]: true,
            [styles.leafletMapContainerSepia]: this.props.sepia,
        });

        const {
            icon,
            divIcon,
            Map,
            Marker,
            Popup,
            point,
            TileLayer,
            MarkerClusterGroup,
            ZoomControl,
        } = this.state.components;

        const createClusterCustomIcon = function (cluster) {
            const count = cluster.getChildCount();

            const clusterClassName = classNames({
                [styles.cluster]: true,
                [styles.clusterOrange]: count >= 10 && count < 20,
                [styles.clusterRed]: count >= 20,
            });

            return divIcon({
                html: `<span>${count}</span>`,
                className: clusterClassName,
                iconSize: point(64, 64, true),
            });
        };

        return (
            <Map center={this.props.center}
                 zoom={zoom}
                 className={leafletMapContainerClassName}
                 scrollWheelZoom={false}
                 maxZoom={18}
                 dragging={this.state.draggable}
                 onClick={this.handleClick}
                 bounds={coordArray.length > 0 ? coordArray.map(item => {
                     return [item.lat, item.lng]
                 }) : null}
                 boundsOptions={{
                     maxZoom: zoom,
                 }}
                 preferCanvas={false}
                 ref={this.mapRef}
                 zoomControl={false}
            >
                <TileLayer
                    url="https://api.mapbox.com/styles/v1/davidgolden/cjq5chqca7mpo2rs06gh00eid/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZGF2aWRnb2xkZW4iLCJhIjoiY2pwZW5oamdwMDIyejNrbzhrMGc4YzlqNiJ9.klBRb1BeqxvmJjqi9f-8yw"
                    attribution='CleverSite - Click to Drag'
                    setParams={true}
                />
                <MarkerClusterGroup
                    showCoverageOnHover={false}
                    iconCreateFunction={createClusterCustomIcon}
                >
                    {coordArray.map((item, i) => {
                        const myIcon = item.icon ? divIcon({...item.icon}) : icon({
                            iconUrl: require("../../assets/images/marker.svg"),
                            iconSize: [48, 48],
                            iconAnchor: [24, 48],
                            popupAnchor: [0, -48],
                            shadowUrl: null,
                            shadowSize: null,
                            shadowAnchor: null
                        });
                        return (
                            <Marker onClick={() => this.props.handleMarkerClick(item)}
                                    icon={myIcon}
                                    key={`${item.lat.toString()}${item.lng.toString()}${i}`}
                                    position={[item.lat, item.lng]}>
                                {item.popup && <Popup>
                                    {item.popup}
                                </Popup>}
                            </Marker>
                        )
                    })}
                </MarkerClusterGroup>
                <ZoomControl position={'bottomright'}/>
            </Map>
        );
    }
}
